import { createTripleButton } from '../../../../common/view/button/triple-button/triple-button';
import { FontSize, FontWeight } from '../../../../common/view/font';

export const MegaBoardColUpgradeButton = createTripleButton({
  sizing: {
    shrinkX: '8px',
    shrinkY: '4px',
    borderRadius: '4px',
    gap: '4px',
  },
  background: {
    color: {
      base: {
        normal: '#ffe600',
        hover: '#e4b300',
      },
    },
  },
  text: {
    size: FontSize.base,
    weight: FontWeight.l1,
    color: {
      base: {
        normal: 'rgb(50, 50, 50)',
      },
    },
  },
  config: {
    componentId: 'mega-board-col-upgrade-button',
    displayName: 'MegaBoardColUpgradeButton',
  },
});
